import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the table view for balance history.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values with specific background colors based on their numeric value.
         * @param {number} value - The value to evaluate.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the background.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        console.log($$('select').getValue() * 1); // Logging the selected value from a dropdown

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component for displaying hierarchical data
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item updates
                                    if (
                                        item.BalanceEnd != item.BalanceEndCalc // Check if calculated balance differs from actual
                                    ) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight item with a background color
                                        if (
                                            item.BalanceEnd > item.BalanceEndCalc // Calculate balance gap
                                        ) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Positive gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Negative gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'Partner', // Column for partner information
                                    header: _('Partner'), // Localized header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Custom template for rendering
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) +
                                                "<span class='partner " +
                                                obj.Partner +
                                                "'></span>"
                                            );
                                        return "<span class='partner " + obj.Partner + "'></span>";
                                    },
                                },
                                {
                                    id: 'CreatedLocalDate', // Column for creation date
                                    header: _('Fecha de creación'), // Localized header
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 120, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                    footer: 'Total:', // Footer content
                                },
                                {
                                    id: 'Country', // Column for country information
                                    header: _('País'), // Localized header
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationCountry',
                                        'Add', // Permission check for visibility
                                    ),
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Custom template for rendering
                                        return "<i class='flags " + obj.Country + "'></i>";
                                    },
                                },
                                {
                                    id: 'UserId', // Column for user ID
                                    header: _('ID Usuario'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column for user name
                                    header: _('Nombre Usuario'), // Localized header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationNames',
                                        'Add', // Permission check for visibility
                                    ),
                                },
                                {
                                    id: 'BalanceInitial', // Column for initial balance
                                    header: _('Saldo Inicial'), // Localized header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'InitialRechargeQuota', // Column for initial recharge quota
                                    header: _('Cupo recargas inicial'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'InitialGameQuota', // Column for initial game quota
                                    header: _('Cupo juego inicial'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountDeposits', // Column for amount of deposits
                                    header: _('Depósitos'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsVirtual', // Column for amount of bets virtual
                                    header: _('Apuestas Virtuales'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinVirtual', // Column for amount of win virtual
                                    header: _('Premios Virtuales'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBets', // Column for amount of bets
                                    header: _('Ap. Deportivas'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWin', // Column for amount won
                                    header: _('Pr. Deportivas'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino', // Column for casino winnings
                                    header: _('Transf Apuesta E'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino', // Column for casino bets
                                    header: _('Transf Apuesta S'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE', // Column for adjustment E
                                    header: _('Transf Recarga E'), // Localized header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentS', // Column for adjustment S
                                    header: _('Transf Recarga S'), // Localized header
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawPaid', // Column for paid withdrawals
                                    header: _('Retiros Pagados'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawDeletes', // Column for deleted withdrawals
                                    header: _('Recargas Eliminadas'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEnd', // Column for final balance
                                    header: _('Saldo Final'), // Localized header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEndCalc', // Column for calculated final balance
                                    header: _('Saldo Final Calc.'), // Localized header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'GrossAmountBetsVirtual', // Column for calculated final balance
                                    header: _('Saldo Bruto Apuestas Virtuales'), // Localized header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'GrossAmountWinVirtual', // Column for calculated final balance
                                    header: _('Saldo Bruto Premios Virtuales'), // Localized header
                                    width: 130, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceGap', // Column for balance gap
                                    header: _('Calc. Desfase'), // Localized header
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    cssFormat: mark_old, // Custom CSS formatting function
                                },
                                {
                                    id: 'retentionsDeposit', // Column for deposit tax
                                    header: _('Impuesto Deposito'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'retentionOnBets', // Column for bet tax
                                    header: _('Impuesto Apuesta'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'retentionOnBetsCasino', // Column for casino bet tax
                                    header: _('Impuesto Apuesta Casino'), // Localized header
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'EndGameQuota', // Column for end game quota
                                    header: _('Cupo'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'EndGameQuotaCalc', // Column for calculated end game quota
                                    header: _('Cupo Calc.'), // Localized header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositAgents', // Column for total deposits to agents
                                    header: _('Total Depósitos a Agentes'), // Localized header
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositUsuOnline', // Column for total deposits to agents
                                    header: _('Total Depósitos Usuarios Online'), // Localized header
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                }
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the component is ready
                                if (!this.count()) {
                                    // Check if there are no data items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: $$('select').getValue() * 1, // Data fetch configuration
                            pager: 'pagerA', // Pager identifier
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryBetShop'; // API endpoint for fetching balance history
        var filter = ''; // Filter string for API requests

        grid.attachEvent('onAfterLoad', function () {
            // Event after data is loaded
            $$('datatable').data.group({
                // Group data by partner
                by: 'Partner',
                map: {
                    Partner: ['Partner'],
                },
            });
        });

        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            // Event listener for filtering balance history
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (object[i][0] == 'Type') {
                    // Check for type filter
                    if (object[i][1] == 0) {
                        // If type is 0, show user ID and name
                        grid.showColumn('UserId', { spans: true });
                        grid.showColumn('UserName', { spans: true });
                    } else {
                        // Otherwise, hide them
                        grid.hideColumn('UserId', { spans: true });
                        grid.hideColumn('UserName', { spans: true });
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    // Handle object filter values
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through nested entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(grid); // Log the grid reference
            grid.clearAll(); // Clear existing data in the grid
            grid.load(
                url + '?start=0&count=' + $$('select').getValue() * 1 + string1, // Load new data with filters
            );
            filter = string1; // Update filter variable
        });
    }
}

// FILE DOCUMENTED
